import { IActivityStreams } from '../../resources/interfaces';
import { Commission } from '../commission/Commission';
import { ICommission } from '../commission/ICommission';
// import { ISales } from '../sales/ISales';
// import { Sales } from '../sales/Sales';
import { Staff } from '../staff/Staff';
import { Company } from '../company/Company';
import { IPayout } from '../payout/IPayout';
import { ISettlement } from './ISettlement';


export class Settlement {
  id: string;
  createdOn: Date | undefined;
  updatedOn: Date | undefined;
  currency: string;
  amountPaid: string;
  dateOfPayment: Date | undefined;
  isPaid: boolean;
  reference: string;
  company: Company | undefined;
  grossToPay: number;
  totalCommissionAmount: number;
  commissions: Commission[];
  isReviewed: boolean;
  isApproved: boolean;
  firstApprovalBy: Staff | null;
  firstApprovalOn: string;
  secondApprovalBy: Staff | null;
  secondApprovalOn: string;
  evidenceUrl?: string;
  activityStreams?: IActivityStreams[];
  payoutType?: string;
  payoutAccount?: any;
  netToPay?: number;
  broker: Company | undefined;
  reviewBy: Staff | null;
  reviewOn: string;
  reviewStage: string;
  title: string;
  transfer: any;
  withholdingTax:number
  brokerName?: string;
  companyName?: string;
  amountReceived?: number;


  constructor(Imodel: ISettlement) {
    this.id = Imodel.id;
    this.createdOn = Imodel.createdOn ? new Date(Imodel.createdOn) : new Date();
    this.updatedOn = Imodel.updatedOn ? new Date(Imodel.updatedOn) : undefined;
    this.dateOfPayment = Imodel.dateOfPayment ? new Date(Imodel.dateOfPayment) : undefined;
    this.totalCommissionAmount = Imodel.totalCommissionAmount;
    this.currency = Imodel.currency;
    this.isPaid = Imodel.isPaid;
    this.grossToPay = Imodel.grossToPay;
    this.reference = Imodel.reference;
    this.amountPaid = Imodel.amountPaid;
    this.company = Imodel.company ? new Company(Imodel.company) : undefined;
    this.commissions = Imodel.commissions ? Imodel.commissions?.map((commission: ICommission) => new Commission(commission)) : [];
    this.isReviewed = Imodel.isReviewed;
    this.firstApprovalBy = Imodel.firstApprovalBy ?? null;
    this.firstApprovalOn = Imodel.firstApprovalOn;
    this.secondApprovalBy = Imodel.secondApprovalBy;
    this.secondApprovalOn = Imodel.secondApprovalOn;
    this.isApproved = Imodel.isApproved;
    this.evidenceUrl = Imodel.evidenceUrl;
    this.activityStreams = Imodel.activityStreams;
    this.payoutType = Imodel.payoutType;
    this.payoutAccount = Imodel.payoutAccount;
    this.netToPay = Imodel.netToPay;
    this.broker = Imodel.broker ? new Company(Imodel.broker) : undefined;
    this.reviewBy = Imodel.reviewBy ?? null;
    this.reviewOn = Imodel.reviewOn;
    this.reviewStage = Imodel.reviewStage;
    this.title = Imodel.title;
    this.transfer = Imodel.transfer;
    this.withholdingTax = Imodel.withholdingTax;
    this.brokerName = Imodel.brokerName;
    this.companyName = Imodel.companyName;
    this.amountReceived = Imodel.amountReceived;
  }
}
